import { FC, useEffect, useRef } from 'react';
import { Box, BoxProps } from '../layout/Box';

type LinearProgressProps = BoxProps & { progress: number };

export const LinearProgress: FC<LinearProgressProps> = ({ progress, ...other }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const lastValueRef = useRef(progress);

    const setProgress = (newProgress: number) => {
        if (!containerRef.current) {
            return;
        }

        containerRef.current.style.transform = `translateX(-${(100 - newProgress).toFixed(2)}%)`;
        containerRef.current.style.transition =
            progress <= lastValueRef.current ? '' : 'transform 0.25s linear 0s';

        lastValueRef.current = newProgress;
    };

    useEffect(() => {
        setProgress(progress ?? 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [progress]);

    return (
        <Box {...other} overflow="hidden">
            <Box
                top={0}
                left={0}
                width="100%"
                height="100%"
                position="absolute"
                backgroundColor="#FFF"
                opacity={0.25}
            />
            <Box
                top={0}
                left={0}
                width="100%"
                height="100%"
                position="absolute"
                backgroundColor="#FFF"
                transformOrigin="left center"
                ref={containerRef}
                style={{
                    transform: 'translateX(-100%)',
                }}
            />
        </Box>
    );
};

LinearProgress.defaultProps = {
    position: 'relative',
    width: '100%',
    height: 4,
    borderRadius: 0.25,
};
